// my-portfolio/src/App.js
import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Portfolio from './Portfolio';

// Disable browser's automatic scroll restoration so we control it
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Reset scroll on route change — skip when hash is present (handled by Portfolio)
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, hash]);
  return null;
};

const DetailedProjectPage = lazy(() => import('./components/DetailedProjectPage'));
const Documentation = lazy(() => import('./components/Documentation'));

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-surface">
    <span className="text-green font-mono text-sm animate-pulse">Loading…</span>
  </div>
);

const NotFound = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-surface px-6 text-center">
    <span className="text-6xl font-mono font-bold text-green/20 mb-4">404</span>
    <h1 className="font-display text-2xl font-bold text-txt mb-2">Page Not Found</h1>
    <p className="text-txt-secondary mb-8 max-w-sm">
      The page you're looking for doesn't exist or has been moved.
    </p>
    <Link
      to="/"
      className="px-6 py-3 bg-green text-surface text-sm font-semibold rounded-lg btn-glow hover:bg-green/90 transition-all duration-300"
    >
      Back to Home
    </Link>
  </div>
);

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/projects/:id" element={<DetailedProjectPage />} />
            <Route path="/docs" element={<Documentation />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </MotionConfig>
  );
}

export default App;
